import { render } from "./radio-help.vue?vue&type=template&id=3390178c"
import script from "./radio-help.vue?vue&type=script&lang=js"
export * from "./radio-help.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__